// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Typography} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomModal from '../../../../elements/CustomModal/CustomModal';

type Props = {
  isSaving?: boolean,
  open: boolean,
  handleClose: () => void,
};
const useStyles = makeStyles(theme => ({
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    margin: theme.spacing(2),
  },
}));

export default function EmailModal(props: Props) {
  const {isSaving, open, handleClose} = props;
  const classes = useStyles();

  const handleCloseModal = () => {
    if (!isSaving) {
      handleClose();
    }
  };

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <Typography className={classes.title} align="center">
        Se envió un correo al cliente con el cuestionario de reseña
      </Typography>
      <CustomButton onClick={handleCloseModal}>Regresar a orden</CustomButton>
    </CustomModal>
  );
}

EmailModal.propTypes = {
  isSaving: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
